module.exports = __webpack_public_path__ + "static/media/HCMM398.39d04bab.jpg";